import React from 'react';
import { useHistory } from 'react-router-dom';
import { StyledToggleButton, StyledToggleButtonGroup } from './styles.module';

export default function NavigationBarToggle({ items, active }) {
  const history = useHistory();

  return (
    <StyledToggleButtonGroup color='primary' value={active} exclusive>
      {items
        .filter(({ display }) => !!display)
        .map(({ title, disabled, value, url }) => (
          <StyledToggleButton
            onClick={() => {
              history.push(url);
            }}
            disabled={disabled}
            key={value}
            value={value}>
            {title}
          </StyledToggleButton>
        ))}
    </StyledToggleButtonGroup>
  );
}
